<template>
  <div class="fantan-sum-player-detail">
    <Row v-if="this.newArr" type="flex" class="fantan-history-trend-lot-cont">
      <Col
        v-for="(col, index) in this.newArr"
        class="fantan-history-trend-lot-col"
        :class="getFanClass(col[3])"
        :key="index"
        ><fantan-history-popper
          :game="game"
          :cell-data="col"
          :table-name="tableName"
          :game-code="gameCode"
          :game-id="gameId"
        >
          <div
            class="fantan-history-trend-lot-cell"
            :class="getFanClass(col[3])"
            v-for="(cell, index) in parseInt(col[3])"
            :key="index"
          >
            {{ col[3] }}
          </div>

          <div class="white-ball" v-for="n in 4 - col[3]"></div>

          <div class="col-length">
            <div>{{ col[3] }}</div>
          </div>
          <div :class="getPBClass(col[4])">
            {{ getOE(col[4]) }}
          </div>
        </fantan-history-popper>
      </Col>
    </Row>
  </div>
</template>

<script>
import { Row, Col } from "iview";
import FantanHistoryPopper from "../widgets/FantanHistoryPopper";
import { TimelineMax } from "gsap";

export default {
  props: ["historicalData", "game", "gameCode", "gameId", "tableName"],
  components: {
    Row,
    Col,
    FantanHistoryPopper,
  },
  data() {
    return {
      tempArr: [],
      newArr: [],
      totalRow: 18,
      o_percentage: 0,
      e_percentage: 0,
      previousBadgeCount: 0,
    };
  },
  methods: {
    getFanClass(value) {
      if (value == 1) return "fan1";
      else if (value == 2) return "fan2";
      else if (value == 3) return "fan3";
      else return "fan4";
    },
    getPBClass(value) {
      if (value == 1) return "odd";
      else return "even";
    },
    getOE(value) {
      if (value == 1) return this.$t("fantan.odd_trend");
      else return this.$t("fantan.even_trend");
    },
    triggerBlinkingEffect() {
      this.$nextTick(() => {
        let animationTl = new TimelineMax();

        animationTl
          .to(
            "#game-" +
              this.gameId +
              " .fantan-sum-player-detail .fantan-history-trend-lot-col.ivu-col:last-of-type",
            0.5,
            {
              opacity: 0,
            }
          )
          .to(
            "#game-" +
              this.gameId +
              " .fantan-sum-player-detail .fantan-history-trend-lot-col.ivu-col:last-of-type",
            0.5,
            {
              opacity: 1,
            }
          );
        animationTl.repeat(4);
      });
    },
  },
  watch: {
    historicalData() {
      this.newArr = [];
      let tempData = [...this.historicalData].slice(0, 18);
      let index = 0;
      this.o_percentage = 0;
      this.e_percentage = 0;

      for (var i = 0; i < tempData.length; i++) {
        let temp = [];
        temp.push(tempData[i]["draw_result"]);
        temp.push(tempData[i]["draw_no"], tempData[i]["draw_datetime"]);
        temp.push(tempData[i]["fan"], tempData[i]["oe"]);
        temp.push(
          tempData[i]["ssh123"],
          tempData[i]["ssh234"],
          tempData[i]["ssh241"],
          tempData[i]["ssh341"]
        );
        temp.push(
          tempData[i]["kwok12"],
          tempData[i]["kwok14"],
          tempData[i]["kwok23"],
          tempData[i]["kwok34"]
        );
        temp.push(
          tempData[i]["1NIM2"],
          tempData[i]["1NIM3"],
          tempData[i]["1NIM4"]
        );
        temp.push(
          tempData[i]["2NIM1"],
          tempData[i]["2NIM3"],
          tempData[i]["2NIM4"]
        );
        temp.push(
          tempData[i]["3NIM1"],
          tempData[i]["3NIM2"],
          tempData[i]["3NIM4"]
        );
        temp.push(
          tempData[i]["4NIM1"],
          tempData[i]["4NIM2"],
          tempData[i]["4NIM3"]
        );

        temp.push(
          tempData[i]["23NGA1"],
          tempData[i]["24NGA1"],
          tempData[i]["34NGA1"]
        );
        temp.push(
          tempData[i]["13NGA2"],
          tempData[i]["14NGA2"],
          tempData[i]["34NGA2"]
        );
        temp.push(
          tempData[i]["12NGA3"],
          tempData[i]["14NGA3"],
          tempData[i]["24NGA3"]
        );
        temp.push(
          tempData[i]["12NGA4"],
          tempData[i]["13NGA4"],
          tempData[i]["23NGA4"]
        );
        this.newArr.push(temp);
      }
      this.newArr.reverse();
      this.triggerBlinkingEffect();
    },
  },
};
</script>

<style lang="scss" scoped>
.fantan-sum-player-detail {
  margin: 15px 0;
}

.fantan-history-trend-lot-cont {
  // justify-content: center;
  margin: 0 -2px;
}

.fantan-history-trend-lot-col {
  background: #574531;
  width: 5.55%;
}

.fantan-history-trend-lot-col:nth-child(8n + 2) {
  background-color: #4a3e2c;
}
.fantan-history-trend-lot-col:nth-child(8n + 4) {
  background-color: #4a3e2c;
}
.fantan-history-trend-lot-col:nth-child(8n + 6) {
  background-color: #4a3e2c;
}
.fantan-history-trend-lot-col:nth-child(8n + 8) {
  background-color: #4a3e2c;
}

.fantan-history-trend-lot-col:hover {
  background: rgb(9, 22, 46);
}

.fantan-history-trend-lot-cell {
  color: #ffffff;
  background: #fff;
  text-align: center;
  font-size: 10px;
  font-weight: bold;
  width: 13px;
  height: 13px;
  border-radius: 100px;
  margin: auto;
  margin-top: 6px;
  box-shadow: 1px 1.5px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.white-ball {
  background: white;
  opacity: 0.5;
  color: #ffffff;
  text-align: center;
  font-size: 10px;
  font-weight: bold;
  width: 13px;
  height: 13px;
  border-radius: 100px;
  margin: auto;
  margin-top: 6px;
  cursor: pointer;
}

.fantan-history-trend-lot-col.ivu-col.fan1 {
  background: #c9c9c9;
}

.fantan-history-trend-lot-col.ivu-col.fan2 {
  background: #16cc86;
}

.fantan-history-trend-lot-col.ivu-col.fan3 {
  background: #f9cb62;
}

.fantan-history-trend-lot-col.ivu-col.fan4 {
  background: #fa4358;
}

.fantan-history-trend-lot-col.ivu-col:hover {
  cursor: pointer;
  background: rgba(51, 116, 194, 0.75) !important;
}

.col-length {
  text-align: center;
  color: #000;
  font-size: 12px;
  font-weight: bold;
  margin-top: 28px;
}

div.odd {
  background: #6f4118;
  color: white;
  text-align: center;
  font-size: 12px;
  line-height: 16px;
  border: 0.1px solid rgba(0, 0, 0, 0.4);
}

div.even {
  background: #f6c964;
  color: #000;
  text-align: center;
  font-size: 12px;
  line-height: 16px;
  border: 0.1px solid rgba(0, 0, 0, 0.4);
}
</style>